import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wfescalation',
  templateUrl: './wfescalation.component.html',
  styleUrls: ['./wfescalation.component.scss']
})
export class WfescalationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
